import React, { useState } from "react";
import { Container, Span, InputContain } from "../GodMode";
import Button from "../../Generic/Button";
import InputBox from "../../Generic/InputBox";

const DITasks = {
	SERVE: "SERVE"
}

const DI_TASKS_CONFIG = {
	[DITasks.SERVE]: { 
		taskType: "serve", 
		name: "Serve Item" 
	},
}

const DI = ({ sendTask, loadingStates }) => {
	const [qpdSlotId, setQpdSlot] = useState(); 
	const isServeLoading = loadingStates[DI_TASKS_CONFIG[DITasks.SERVE].taskType] || false;

	const handleButtonClick = async () => {
		const taskData = qpdSlotId ? { qpdSlotId } : {};
		await sendTask(DI_TASKS_CONFIG[DITasks.SERVE], taskData);
	}

	return (
		<Container>
			<Container>
				<InputContain margin="0 1rem 0 0">
					<Span padding="0 0 0.5rem 0" fontSize="1rem" fontWeight="600">
						QPD Slot Id
					</Span>
					<InputBox
						onChange={(e) => {
							setQpdSlot(e.target.valueAsNumber);
						}}
						type="number"
						required
					/>
				</InputContain>
				<Button onClick={handleButtonClick} disabled={isServeLoading}>
					Serve
				</Button>
			</Container>
		</Container>
	);
};

export default DI;
